"use client";

import { Header } from "@/components/header";
import { Footer } from "@/components/footer";
import { motion } from "framer-motion";
import { intl } from "@/lib/i18n";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

export default function FaqClient() {
  const faqs: any[] = [];

  faqs.push(
    {
      question: intl.get("faq.tips1"),
      answer: intl.get("faq.subTips1"),
    },
    {
      question: intl.get("faq.tips2"),
      answer: intl.get("faq.subTips2"),
    },
    {
      question: intl.get("faq.tips3"),
      answer: intl.get("faq.subTips3"),
    },
    {
      question: intl.get("faq.tips4"),
      answer: intl.get("faq.subTips4"),
    },
    {
      question: intl.get("faq.tips5"),
      answer: intl.get("faq.subTips5"),
    },
    {
      question: intl.get("faq.tips6"),
      answer: intl.get("faq.subTips6"),
    },
    {
      question: intl.get("faq.tips7"),
      answer: intl.get("faq.subTips7"),
    },
    {
      question: intl.get("faq.tips8"),
      answer: intl.get("faq.subTips8"),
    }
  );

  return (
    <div>
      {/* Header Section */}
      <motion.div
        className="pt-32 pb-16"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="container">
          <div className="pb-12 md:pb-20">
            <div className="mb-8 flex justify-center md:flex">
              <h2 className="font-hkgrotesk mb-4 text-center text-3xl font-extrabold md:mb-0 md:text-4xl">
                {intl.get("faq.title")}
              </h2>
            </div>
            <Accordion type="multiple" className="mt-8">
              {faqs.map((faq, index) => (
                <AccordionItem value={`item-${index}`} key={index}>
                  <AccordionTrigger className="text-left">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent>{faq.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
